import { render, staticRenderFns } from "./PopReadNews.vue?vue&type=template&id=733fe2d0&lang=pug"
import script from "./PopReadNews.vue?vue&type=script&lang=js"
export * from "./PopReadNews.vue?vue&type=script&lang=js"
import style0 from "./PopReadNews.vue?vue&type=style&index=0&id=733fe2d0&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports